import { Injectable, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Subject, BehaviorSubject, Observable } from 'rxjs';
import { ActivatedRoute, Router, NavigationEnd, NavigationStart, Params, ActivatedRouteSnapshot, RouterEvent } from '@angular/router';
import { filter } from 'rxjs/operators';
import * as _ from "lodash";
import { GeolocationClient, AdveristmentsClient, DTOSubRegion } from '../api/WickedApiClient';
//import { regexSearch } from '../app-routing.module';


interface ParamsSearchData {
  casualDating: boolean,
  categoryId: number,
  withPicture: boolean,
  state?: number,
  city?: number,
  radius?: number,
  zipCode?: string
}

interface ParamsData {
  paramsSearchData?: ParamsSearchData,
  params?: Params,
  isSearchByZip?: boolean,
  isValid: boolean
}

interface CategoryRouteData {
  categoryId: number,
  categoryKey: string,
  casualDating: boolean
}

//search-results/:casualDating/:relationShip/:withPicture/:state/:city

export const Categories: { [key: string]: number } = {
  "women-seeking-men": 1,
  "women-seeking-women": 2,
  "women-seeking-couples": 3,
  "women-seeking-transgenders": 4,
  "men-seeking-women": 5,
  "men-seeking-men": 6,
  "men-seeking-couples": 7,
  "men-seeking-transgenders": 8,
  "couples-seeking-women": 9,
  "couples-seeking-men": 10,
  "couples-seeking-couples": 11,
  "couples-seeking-transgenders": 12,
  "transgenders-seeking-women": 13,
  "transgenders-seeking-men": 14,
  "transgenders-seeking-couples": 15,
  "transgenders-seeking-transgenders": 16,
  "missed-connections": 17
};

export const RegexSearchList = `^(?<state>[a-z]{2})(?:-)(?<city>[\\w\\W]+)(?:-)\\b(?:(?<type>casual-dating|long-term))((?:-)\\b(?:(?<category>${Object.keys(Categories).join("|")})))?(?:(?<withPicture>-with-picture))?((?:-)(?<page>page-[0-9]+))?((?:-)(?<per>per-(4|12|24|100)))?`;
export const RegexCategory = `^(?<type>casual-dating|long-term)-(?<category>${Object.keys(Categories).join("|")})$`;
export const RegexCity = `^(?<state>[a-z]{2})(?:-)(?<city>[\\w\\W]+)$`;
export const RegexSearchResults = `^search-results((?:-)(?<page>page-[0-9]+))?((?:-)(?<per>per-(4|12|24|100)))?`;

export const States: { [key: string]: number } = {
  "WA": 3,
  "IL": 4,
  "GA": 5,
  "IN": 6,
  "IA": 7,
  "MA": 8,
  "AZ": 9,
  "ID": 10,
  "CT": 11,
  "ME": 12,
  "MD": 13,
  "VT": 14,
  "OK": 15,
  "UT": 16,
  "MO": 17,
  "MN": 18,
  "MI": 19,
  "KS": 20,
  "MT": 21,
  "MS": 22,
  "PR": 23,
  "SC": 24,
  "KY": 25,
  "OH": 26,
  "AR": 27,
  "AL": 28,
  "CA": 29,
  "DE": 30,
  "DC": 31,
  "WI": 32,
  "WV": 33,
  "HI": 34,
  "FL": 35,
  "WY": 36,
  "NH": 37,
  "NJ": 38,
  "NM": 39,
  "TX": 40,
  "LA": 41,
  "AK": 42,
  "NC": 43,
  "ND": 44,
  "NE": 45,
  "TN": 46,
  "NY": 47,
  "PA": 48,
  "RI": 49,
  "NV": 50,
  "VA": 51,
  "CO": 52,
  "OR": 53,
  "SD": 54
}

@Injectable({ providedIn: 'root' })
export class SearchRouteService {


  categories: { [key: string]: number } = {
    "women-seeking-men": 1,
    "women-seeking-women": 2,
    "women-seeking-couples": 3,
    "women-seeking-transgenders": 4,
    "men-seeking-women": 5,
    "men-seeking-men": 6,
    "men-seeking-couples": 7,
    "men-seeking-transgenders": 8,
    "couples-seeking-women": 9,
    "couples-seeking-men": 10,
    "couples-seeking-couples": 11,
    "couples-seeking-transgenders": 12,
    "transgenders-seeking-women": 13,
    "transgenders-seeking-men": 14,
    "transgenders-seeking-couples": 15,
    "transgenders-seeking-transgenders": 16,
    "missed-connections": 17
  };

  states: { [key: string]: number } = {
    "WA": 3,
    "IL": 4,
    "GA": 5,
    "IN": 6,
    "IA": 7,
    "MA": 8,
    "AZ": 9,
    "ID": 10,
    "CT": 11,
    "ME": 12,
    "MD": 13,
    "VT": 14,
    "OK": 15,
    "UT": 16,
    "MO": 17,
    "MN": 18,
    "MI": 19,
    "KS": 20,
    "MT": 21,
    "MS": 22,
    "PR": 23,
    "SC": 24,
    "KY": 25,
    "OH": 26,
    "AR": 27,
    "AL": 28,
    "CA": 29,
    "DE": 30,
    "DC": 31,
    "WI": 32,
    "WV": 33,
    "HI": 34,
    "FL": 35,
    "WY": 36,
    "NH": 37,
    "NJ": 38,
    "NM": 39,
    "TX": 40,
    "LA": 41,
    "AK": 42,
    "NC": 43,
    "ND": 44,
    "NE": 45,
    "TN": 46,
    "NY": 47,
    "PA": 48,
    "RI": 49,
    "NV": 50,
    "VA": 51,
    "CO": 52,
    "OR": 53,
    "SD": 54
  }

  public paramsData: Subject<ParamsData>;
  public categoryData: Subject<CategoryRouteData>;
  public params: BehaviorSubject<Params>;
  public paramsSnapshot: Params;

  constructor(private router: Router, private advertisementsClient: AdveristmentsClient) {

    this.router = router;

    this.paramsSnapshot = {};
    this.params = new BehaviorSubject(this.paramsSnapshot);
    this.paramsData = new Subject();
    this.categoryData = new Subject();

    this.router.events
      .pipe(
        filter(
          (event: RouterEvent): boolean => {
            return (event instanceof NavigationEnd);
          }
        )
      )
      .subscribe(
        (event: NavigationEnd): void => {
          if (this.router.url.indexOf("/search-results/") == 0) {
            var snapshot = this.router.routerState.snapshot.root;
            var nextParams = this.collectParams(snapshot);
            if (this.paramsAreDifferent(this.paramsSnapshot, nextParams)) {
              this.getParamsData(nextParams).subscribe(data => {
                this.paramsData.next(data);
              });
              this.params.next(this.paramsSnapshot = nextParams);
            }
          } else {
            let categoriesKeys = Object.keys(this.categories);
            for (var i = 0; i < categoriesKeys.length; i++) {
              if (this.router.url.indexOf(`/casual-dating/${categoriesKeys[i]}`) == 0) {
                this.categoryData.next({ casualDating: true, categoryKey: categoriesKeys[i], categoryId: this.categories[categoriesKeys[i]] });
                break;
              } else if (this.router.url.indexOf(`/long-term/${categoriesKeys[i]}`) == 0) {
                this.categoryData.next({ casualDating: false, categoryKey: categoriesKeys[i], categoryId: this.categories[categoriesKeys[i]] });
                break;
              }
            }
          }
        }
      );
  }

  public isRouteSearch(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.router.events
        
        .subscribe((event: NavigationStart) => {
          console.log(event);
         let regexSearch = `^(?<state>[a-z]{2})(?:-)(?<city>[\\w\\W]+)(?:-)\\b(?:(?<type>casual-dating|long-term))((?:-)\\b(?:(?<category>${Object.keys(Categories).join("|")})))?(?:(?<withPicture>-with-picture))?`;

          let regex = new RegExp(regexSearch, "gi");
          var regexMatch = regex.exec(event.url.replace("/", ""));
          if (regexMatch != null && (regexMatch as any).groups != null) {
            resolve(true);
          } else {
            resolve(false);
          }
          
        });
    });
  }

  public getCategoryUrl(categoryId: number) {
    let url = "";
    for (var i in this.categories) {
      if (this.categories[i] == categoryId) {
        url = `${i}`;
      }
    }

    return url;
  }

  private getParamsData(params: Params) {
    return new Observable<ParamsData>(observable => {
      if (!this.validateRequest(params)) {
        observable.next({ isValid: false });
      }

      let isSearchByZip = !isNaN(params["state"]);

      let casualDating = params["casualDating"] as string;
      let relationship = params["relationShip"] as string
      let withPicture = params["withPicture"] as string;
      let state = params["state"] as string;
      let city = params["city"] as string;

      let data: ParamsData = {
        isValid: true,
        params: params,
        isSearchByZip: isSearchByZip,
        paramsSearchData: {
          casualDating: casualDating.toLowerCase() == 'casual-dating',
          categoryId: this.categories[relationship.toLowerCase()],
          withPicture: withPicture == "with-picture",
        }
      }

      if (isSearchByZip) {
        data.paramsSearchData.radius = Number(state);
        data.paramsSearchData.zipCode = city;
        observable.next(data);
      } else {
        data.paramsSearchData.state = this.states[state];
        this.advertisementsClient.getChildrenSubRegions(data.paramsSearchData.state).toPromise().then((cities) => {
          let c: DTOSubRegion[] = cities.filter(c => c.zip == city);
          if (c.length) {
            data.paramsSearchData.city = c[0].subRegionId;
            observable.next(data);
          }
        });
      }
    });



  }

  private validateRequest(params: Params): boolean {
    let casualDating = params["casualDating"] as string;
    let relationship = params["relationShip"] as string
    let withPicture = params["withPicture"] as string;
    let state = params["state"] as string;
    let city = params["city"] as string;

    if (casualDating == null || relationship == null || withPicture == null || state == null || city == null) {
      return false;
    }

    if (["casual-dating", "long-term"].indexOf(casualDating.toLowerCase()) == -1) {
      return false;
    }

    if (this.categories[relationship.toLowerCase()] == null) {
      return false;
    }

    if (["all", "with-picture"].indexOf(withPicture.toLowerCase()) == -1) {
      return false;
    }

    return true;
  }

  private collectParams(root: ActivatedRouteSnapshot): Params {

    var params: Params = {};

    (function mergeParamsFromSnapshot(snapshot: ActivatedRouteSnapshot) {

      params = {
        ...snapshot.params
      }

      snapshot.children.forEach(mergeParamsFromSnapshot);

    })(root);

    return (params);

  }

  private paramsAreDifferent(
    currentParams: Params,
    nextParams: Params
  ): boolean {

    var currentKeys = Object.keys(currentParams);
    var nextKeys = Object.keys(nextParams);

    if (currentKeys.length !== nextKeys.length) {
      return (true);
    }

    for (var i = 0, length = currentKeys.length; i < length; i++) {

      var key = currentKeys[i];

      if (currentParams[key] !== nextParams[key]) {

        return (true);
      }

    }

    return (false);

  }
}
